import type { CSSInterpolation } from '@emotion/serialize';

import { BuildType } from '../../enums/build/build-type';

import type { Colors } from './colors';
import type { Fonts } from './fonts';

export type CommonStyle = {
  link: CSSInterpolation;
  defaultList: CSSInterpolation;
  headerStyle: CSSInterpolation;
  pageTitleStyle: CSSInterpolation;
  focusOutline: CSSInterpolation;
};

export const getCommon = (buildType: BuildType, colors: Colors, fonts: Fonts): CommonStyle => {
  const isMeridian = buildType === BuildType.MERIDIAN;
  return {
    link: [
      fonts.regular,
      {
        color: isMeridian ? colors.meridianBlue : colors.highlightText,
        textDecoration: 'underline',
        cursor: 'pointer',
      },
    ],
    defaultList: {
      listStyle: 'disc',
      padding: '0 0.25rem',
      li: [
        fonts.regular,
        {
          'color': isMeridian ? colors.capeCod : colors.highlightText,
          'marginLeft': '1.25rem',
          'display': 'list-item',
          '*': {
            color: isMeridian ? colors.capeCod : colors.bodyText,
          },
        },
      ],
    },
    headerStyle: {
      textTransform: buildType === BuildType.HARBOUR ? 'uppercase' : undefined,
    },
    pageTitleStyle: {
      letterSpacing: buildType === BuildType.HARBOUR ? [undefined, '1rem'] : undefined,
    } as CSSInterpolation,
    focusOutline: {
      outline: `solid ${colors.focusOutlineColor} 5px`,
      outlineOffset: '3px',
    },
  };
};
